module.exports = __webpack_public_path__ + "4aff55ce83330d6f5d3ddc327bb87006.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-17.png
// module id = 2127
// module chunks = 0